export default "__VITE_ASSET__ZpHPdsGx__"